import React, { CSSProperties } from "react";

interface TextInputProps {
  label?: string;
  name?: string;
  value?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  Component?: string;
  maxLength?: number;
  allowDecimal?: boolean;
  limit?: [number, number];
  required?: boolean;
  className?: string; // For additional custom classes
  style?: CSSProperties; // Inline styling for the container
  showAmountLabel?: boolean;
  amountLabel?: string;
}

const NumberInput: React.FC<TextInputProps> = ({
  label,
  name,
  value,
  onChange,
  error,
  touched,
  disabled,
  Component = "",
  maxLength,
  allowDecimal = false,
  limit = [8, 2],
  required = false,
  className = "",
  style = {},
  showAmountLabel,
  amountLabel,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const [integerLimit, decimalLimit] = limit;
    const regex = allowDecimal
      ? new RegExp(`^\\d{0,${integerLimit}}(\\.\\d{0,${decimalLimit}})?$`)
      : new RegExp(`^\\d{0,${maxLength || integerLimit}}$`);

    if (regex.test(inputValue)) {
      onChange(e);
    }
  };

  return (
    <div className={`mb-0 ${className}`} style={style}>
      <div className="input-group">
        <div className="form-floating flex-grow-1">
          <input
            type="text"
            className={`form-control ${touched && error ? "is-invalid" : ""}`}
            id={`txt${Component}${name}`}
            name={name}
            value={value}
            onChange={handleChange}
            placeholder=" "
            disabled={disabled}
            maxLength={maxLength}
          />

          <label htmlFor={`txt${Component}${name}`}>
            {label}
            {!disabled && required && <span style={{ color: "red" }}>*</span>}
          </label>

          {touched && error && <div className="invalid-feedback">{error}</div>}
        </div>

        {showAmountLabel && amountLabel && (
          <span className="input-group-text">{amountLabel}</span>
        )}
      </div>
    </div>
  );
};

export default NumberInput;
